import React from 'react';
import planIcon from '../../../../../../assets/image/subscription/plan-icon.svg';
import Button from '../../../../../../component/ui/Button';
import { format2DigitDate } from '../../../../../../utils/constant';
import { axiosInstanceV2 } from '../../../../../../services/axios';
import { toast } from 'react-toastify';
import { loadRazorpay } from '../../../../../../utils/loadRazorpay';

export default function CurrentPlanComponents({
	currentPlan,
	setIsOpenCancelSubscriptionModal,
	setSubscriptionScreenType,
}) {

	const isFreePlan =
		currentPlan?.is_free || currentPlan?.plan?.key === "free";

	const isPaused = currentPlan?.status === 'paused';
	const isActive = currentPlan?.status === 'active';
	const isRecurring = !!currentPlan?.is_recurring;


	const getStatusStyle = (status) => {
		switch (status) {
			case 'active':
				return { backgroundColor: '#F0FFE6', color: '#68C230' };
			case 'paused':
				return { backgroundColor: '#F3EEFF', color: '#8B5CF6' };
			case 'created':
			case 'authenticated':
				return { backgroundColor: '#EEF6FF', color: '#0D6EFD' };
			case 'pending':
				return { backgroundColor: '#FFF8E6', color: '#E6A700' };
			case 'halted':
				return { backgroundColor: '#FFF4E5', color: '#E67E22' };
			case 'cancelled':
			case 'expired':
			case 'superseded':
				return { backgroundColor: '#FDECEC', color: '#DC3545' };
			default:
				return { backgroundColor: '#F5F5F5', color: '#6C757D' };
		}
	};

	const handleResumeSubscription = async () => {
		try {
			const token = localStorage.getItem('authToken');
			const response = await axiosInstanceV2.get('/subscription/resume', {
				headers: { Authorization: `Bearer ${token}` },
			});

			const result = response.data.data;

			if (result.type === 'resumed') {
				toast.success('Subscription resumed successfully! Auto-renewal is back on.');
				window.location.reload();
				return;
			}

			if (result.type === 'resubscribed') {
				toast.info('Please complete payment to reactivate your subscription');

				const razorpayLoaded = await loadRazorpay();
				if (!razorpayLoaded) {
					toast.error('Razorpay SDK failed to load');
					return;
				}
				const options = {
					key: result.razorpay_key_id,
					subscription_id: result.subscription_id,
					name: 'Pharmnex',
					description: `${result.plan_name} - ${result.billing_period}`,
					currency: result.currency ?? 'INR',
					recurring: 1,
					handler: async () => {
						toast.success('Subscription reactivated successfully 🎉');
						window.location.reload();
					},
					modal: {
						ondismiss: () => toast.info('Payment cancelled'),
					},
					theme: { color: '#3B58FF' },
				};

				const rzp = new window.Razorpay(options);
				rzp.open();
			}

		} catch (error) {
			toast.error(error?.response?.data?.message ?? 'Failed to resume subscription');
		}
	};

	const handleCancelScheduledDowngrade = async () => {
		try {
			const token = localStorage.getItem("authToken");
			await axiosInstanceV2.post(
				"/subscription/cancel-scheduled-downgrade",
				{},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);
			toast.success("Scheduled downgrade cancelled.");
			window.location.reload();

		} catch (error) {
			console.log(error)
			toast.error(
				error?.response?.data?.message ??
				"Unable to cancel scheduled downgrade."
			);
		}
	};

	const handleTestDowngradeImmediately = async () => {
		try {
			const token = localStorage.getItem("authToken");

			await axiosInstanceV2.get(
				`/worker/test-downgrade-subscription`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			toast.success("Downgraded Successfully");
			window.location.reload();

		} catch (error) {
			console.log(error)
			toast.error(
				error?.response?.data?.message ??
				"Unable to downgrade."
			);
		}
	};

	const handleTestDowngradeToFreeImmediately = async () => {
		try {
			const token = localStorage.getItem("authToken");

			await axiosInstanceV2.get(
				`/worker/test-downgrade-to-free`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			toast.success("Downgraded To Free Successfully");
			window.location.reload();

		} catch (error) {
			console.log(error)
			toast.error(
				error?.response?.data?.message ??
				"Unable to downgrade to free."
			);
		}
	};

	return (
		<div>
			<div className="fs-3 fw-semibold py-2">Current Subscription</div>

			{currentPlan?.is_downgrade_scheduled &&
				<div
					className="mb-3 rounded-3 p-3"
					style={{ background: "#EEF6FF", border: "1px solid #6EA8FE" }}
				>
					<div className="d-flex align-items-center gap-4">
						<span style={{ fontSize: 20 }}>📅</span>
						<div className="fw-semibold d-flex align-items-center gap-2">Downgrade Scheduled<div
							className="fs-5 font-small text-danger cursor-pointer"
							onClick={handleTestDowngradeImmediately}
						>
							Click To Downgrade Now!
						</div></div>
					</div>
					<div className="mt-2 fs-5">
						Your subscription will automatically change to{" "}
						<strong>{currentPlan?.downgrade_plan?.name}</strong> on{" "}
						<strong>{format2DigitDate(currentPlan?.downgrade_at)}</strong>.
					</div>
					<div className="mt-1 fs-5 text-muted">
						You'll continue enjoying your current plan until then.
					</div>
				</div>
			}

			{/* {currentPlan?.is_scheduled_for_cancellation && (
				<div
					className="mb-3 rounded-3 p-3"
					style={{ background: "#FFF8E6", border: "1px solid #F4C46B" }}
				>
					<div className="d-flex align-items-center gap-2">
						<span style={{ fontSize: 20 }}>⚠️</span>
						<div className="fw-semibold text-dark">
							Subscription Scheduled for Cancellation
						</div>
					</div>
					<div className="mt-2 fs-5">
						Your subscription will remain active until{" "}
						<strong>{format2DigitDate(currentPlan.current_end)}</strong>.
					</div>
					<div className="mt-1 fs-5 text-muted">
						Auto-renewal has been turned off, so you won't be charged again.
					</div>
					<hr className="my-3" />
					<div className="fs-5">
						If you'd like to continue using your current plan after{" "}
						<strong>{format2DigitDate(currentPlan.current_end)}</strong>, you can
						purchase a new subscription once your current subscription ends.
					</div>
				</div>
			)} */}

			{/* Paused banner — only reachable for recurring plans */}
			{isPaused && (
				<div
					className="mb-3 rounded-3 p-3"
					style={{ background: "#F3EEFF", border: "1px solid #B39DFF" }}
				>
					<div className="d-flex align-items-center gap-2">
						<span style={{ fontSize: 20 }}>⏸️</span>
						<div className="fw-semibold text-dark">Subscription Paused</div>
					</div>
					<div className="mt-2 fs-5">
						You still have full access to your current plan until{" "}
						<strong>{format2DigitDate(currentPlan?.current_end)}</strong>. No
						charge will be made while paused.
					</div>
					<div className="mt-1 fs-5 text-muted">
						If you don't resume before then, your account will automatically
						move to the Free plan — you won't lose any data.
					</div>
					<hr className="my-3" />
					<div className="fs-5">
						Resume anytime before{" "}
						<strong>{format2DigitDate(currentPlan?.current_end)}</strong> to
						pick up billing exactly where you left off, with no interruption.
					</div>
				</div>
			)}

			{isActive && !isRecurring && !isFreePlan && !currentPlan?.is_downgrade_scheduled && !currentPlan?.is_scheduled_for_cancellation && (
				<div
					className="mb-3 rounded-3 p-3"
					style={{ background: "#F5F5F5", border: "1px solid #D9D9D9" }}
				>
					<div className="fs-5 text-muted">
						This is a one-time plan valid until{" "}
						<strong>{format2DigitDate(currentPlan?.current_end)}</strong>. It
						won't auto-renew — once it ends, your account moves to the Free
						plan automatically. You can subscribe again anytime.
					</div>
					<div className='fs-5 font-small text-danger cursor-pointer' onClick={handleTestDowngradeToFreeImmediately}>
						Click here to downgrade to free plan.
					</div>
				</div>
			)}

			<div
				className="d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center rounded-3 p-2"
				style={{
					border: '1px solid rgba(85, 91, 103, 0.15)',
					backgroundColor: 'rgba(252, 252, 252, 1)',
				}}
			>
				<div className="d-flex justify-content-start align-items-center p-2">
					<img src={planIcon} className="px-2" alt="icon" />
					<div className="px-3">
						<div className="d-flex gap-4 align-items-center">
							<div className="fs-4 font-medium">{`${currentPlan?.plan?.name || 'Free Plan'}`}</div>
							<div
								className="p-2 fs-5 font-small rounded-4"
								style={{ ...getStatusStyle(currentPlan?.status), width: '50px' }}
							>
								{currentPlan?.status}
							</div>
						</div>
						<div className="fs-5 font-small">Description: {currentPlan?.plan?.description || 'N/A'}</div>
						<div className="fs-5 font-small">
							{
								isFreePlan
									? "No payment subscription"
									: `Subscription Id : ${currentPlan?.razorpay_subscription_id}`
							}
						</div>
					</div>
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3 py-2">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Amount'}</div>
					</div>
					{
						isFreePlan ? (
							<>
								<div className="fs-5 font-small text-success">Free Forever</div>
								<div className="fs-5 font-small">No recurring charges</div>
							</>
						) : (
							<>
								<div className="fs-5 font-small">
									₹ {currentPlan?.amount} / {currentPlan?.billing_period}
								</div>
								<div className="fs-5 font-small">
									{isPaused ? 'Billing paused' : `Billed ${currentPlan?.billing_period}`}
								</div>
							</>
						)
					}
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3 py-2">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Validity'}</div>
					</div>
					<div className="fs-5 font-small">{`${currentPlan?.current_start !== null ? format2DigitDate(currentPlan?.current_start) : ''} - ${currentPlan?.current_end !== null ? format2DigitDate(currentPlan?.current_end) : ''}`}</div>
					{currentPlan?.is_downgrade_scheduled ? (
						<div className="fs-5 font-small text-primary">
							Downgrades on {format2DigitDate(currentPlan.downgrade_at)}
						</div>
					) : isPaused ? (
						<div className="fs-5 font-small" style={{ color: '#8B5CF6' }}>
							Moves to Free on {format2DigitDate(currentPlan?.current_end)} if not resumed
						</div>
					) : currentPlan?.next_billing_date ? (
						<div className="fs-5 font-small">
							Next billing on {format2DigitDate(currentPlan.next_billing_date)}
						</div>
					) : currentPlan?.is_scheduled_for_cancellation ? (
						<div className="fs-5 font-small text-warning">
							Subscription ends on {format2DigitDate(currentPlan.current_end)}
						</div>
					) : !isRecurring && !isFreePlan ? (
						<div className="fs-5 font-small text-muted">
							Moves to Free on {format2DigitDate(currentPlan?.current_end)}
						</div>
					) : null}
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3 py-2">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Status'}</div>
					</div>
					<div
						className="p-2 fs-5 font-small rounded-4"
						style={{
							backgroundColor:
								currentPlan?.is_downgrade_scheduled ? "#EEF6FF"
									: isPaused ? "#F3EEFF"
										: currentPlan?.is_scheduled_for_cancellation ? "#FFF4E5"
											: "#F0FFE6",
							color:
								currentPlan?.is_downgrade_scheduled ? "#0D6EFD"
									: isPaused ? "#8B5CF6"
										: currentPlan?.is_scheduled_for_cancellation ? "#E67E22"
											: "#68C230",
						}}
					>
						{
							currentPlan?.is_downgrade_scheduled ? "Downgrade Scheduled"
								: isPaused ? "Paused"
									: currentPlan?.is_scheduled_for_cancellation ? "Scheduled for Cancellation"
										: currentPlan?.status
						}
					</div>
					<div className="fs-5 font-small">
						{
							!isFreePlan && isRecurring && (
								<div className="fs-5 font-small">
									Auto Renewal
									<span
										className={`ms-2 fw-semibold ${currentPlan?.auto_renewal
											? "text-success"
											: "text-danger"
											}`}
									>
										{currentPlan?.auto_renewal ? "ON" : "OFF"}
									</span>
								</div>
							)
						}
					</div>
				</div>
				<div className="align-items-center justify-content-end px-3 py-2 ">
					{
						!isFreePlan && <Button
							type="button"
							className="mt-0 btn-primary fs-5 fw-light add-pro py-1 px-4"
							button="Manage Billing"
							onClick={() => setSubscriptionScreenType("manage-billing")}
						/>
					}
					{
						currentPlan?.is_downgrade_scheduled && (
							<div>
								<div
									className="mt-3 fs-5 font-small text-warning cursor-pointer"
									onClick={handleCancelScheduledDowngrade}
								>
									Cancel Downgrade
								</div>
							</div>
						)
					}
					{isPaused && isRecurring && (
						<div
							className="mt-3 fs-5 font-small text-primary cursor-pointer"
							onClick={handleResumeSubscription}
						>
							Resume Subscription
						</div>
					)}
					{/* Pause — recurring, currently active, and not already scheduled to cancel */}
					{!isFreePlan && isActive && isRecurring && !currentPlan?.cancel_at_cycle_end && !currentPlan?.is_downgrade_scheduled && (
						<div
							className="mt-3 fs-5 font-small text-danger cursor-pointer"
							onClick={() => setIsOpenCancelSubscriptionModal(true)}
						>
							Pause Subscription
						</div>
					)}
				</div>
			</div>
		</div>
	);
}